<!--
 * @Author: your name
 * @Date: 2020-05-12 18:29:36
 * @LastEditTime: 2021-04-25 17:13:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_dev\src\views\salesTerminal\contractInfo\FormView.vue
-->
<template>
    <v-touch
        @swiperight="swiperright"
        @pinchout="pinchout"
        @pinchin="pinchin"
        class="wrapper"
    >
        <div class="form-view">
            <van-nav-bar
                title="表单预览"
                left-text="合同详情"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <iframe
                    :src="src"
                    frameborder="0"
                ></iframe>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 表单缩放
    name: 'form-view',
    components: {},
    props: {},
    data() {
        return {
            token: '',
            src: '',
            params: {},
            detail: {},
        };
    },
    computed: {},
    watch: {},
    created() {
        this.params = this.$route.params.params;
        this.detail = this.$route.params.detail;
        this.token = window.localStorage.getItem('token');
        this.src = '' + this.GLOBAL.FORM_BASE_URL + 'angularForm/FormView.html?FormCode=' + this.params.FormCode + '&'
                + 'frameId=' + this.params.FormId + '&'
                + 'FormUseInJiYunFlow=true&'
                + 'PKValues=' + this.params.FormKeyValue + '&'
                + 'IsView=' + this.params.IsRead + '&'
                + 'businessInstanceId=' + this.detail.businessInstanceId + '&'
                + 'DeviceType=2&'
                + 'token=' + this.token;
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            // this.$router.push({ name: 'contractDetails' });
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            // this.$router.push({ name: 'contractDetails' });
            this.$router.go(-1);
        },
        pinchout() {
            alert(2);
        },
        pinchin() {
            alert(3);
        },
    },
};
</script>
<style lang="stylus" scoped>
.form-view
    height 100%
    section
        height calc(100% - 45rpx)
        overflow hidden
        iframe
            width 100%
            height 100%
</style>